class ProductSelector extends HTMLElement {
  constructor() {
    super();
    this.inputWrapper = "[data-input-wrapper]";
    this.variants = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    );
    this.form = document.querySelector(
      `#ProductForm-${this.dataset.sectionId}`
    );
    this.purchaseOptions = document.querySelector(
      `#Product-Purchase-Options-${this.dataset.sectionId}`
    );
    this.productBar = document.querySelector(
      `#ProductBar-${this.dataset.sectionId}`
    );
    this.installmentsForm = document.querySelector(
      `#Product-Installments-${this.dataset.installmentsFormId}`
    );

    this.addEventListener("change", this.onVariantChange.bind(this));

    this.updateOptions();
    this.updateVariantStatuses();
    this.updateVariant();
    this.variantColorSwatch();
    // this.form.toggleAddButton(!this.currentVariant.available, '');
    this.inactiveOptions();
    this.sizeGuideUnits();
    this.productColorsMetafield();

    this.handleSwatchListForSmallScreens();
  }
  productColorsMetafield() {
    console.log("ok");
    const colorways = this.querySelectorAll(".each_colorway");

    // Add click event listener to each colorway
    colorways.forEach((colorway) => {
      colorway.addEventListener("click", async (event) => {
        event.preventDefault(); // Prevent default link behavior

        const url = colorway.href; // Get URL from href attribute
        try {
          const response = await fetch(url); // Fetch the URL
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const content = await response.text(); // Get the response text

          const parser = new DOMParser();
          const doc = parser.parseFromString(content, "text/html"); // Parse the HTML

          const newContent = doc.querySelector(".main-product"); // Adjust the selector based on the structure of the fetched page

          if (newContent) {
            const productSection = document.querySelector(".main-product");
            productSection.innerHTML = newContent.innerHTML; // Update the section with new content
            // Change the browser's URL using the History API
            window.history.pushState(null, "", url);
          }
        } catch (error) {
          console.error("Error fetching the product details:", error);
        }
      });
    });
  }
  productColorsMetafield() {
    console.log("ok");
    const colorways = this.querySelectorAll(".each_colorway");

    // Add click event listener to each colorway
    colorways.forEach((colorway) => {
      colorway.addEventListener("click", async (event) => {
        event.preventDefault(); // Prevent default link behavior

        const url = colorway.href; // Get URL from href attribute
        try {
          const response = await fetch(url); // Fetch the URL
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const content = await response.text(); // Get the response text

          const parser = new DOMParser();
          const doc = parser.parseFromString(content, "text/html"); // Parse the HTML

          const newContent = doc.querySelector(".main-product"); // Adjust the selector based on the structure of the fetched page

          if (newContent) {
            const productSection = document.querySelector(".main-product");
            productSection.innerHTML = newContent.innerHTML; // Update the section with new content
            // Change the browser's URL using the History API
            window.history.pushState(null, "", url);
          }
        } catch (error) {
          console.error("Error fetching the product details:", error);
        }
      });
    });
  }


  sizeGuideUnits() {
    // Get buttons and table
    const cmBtn = document.getElementById("cm-btn");
    const inchesBtn = document.getElementById("inches-btn");
    const table = document.querySelector(".page-size-guide-table");

    // Convert cm to inches
    const cmToInches = (cm) => {
     return (cm * 0.393701).toFixed(1);
     };

    // Convert inches to cm
     const inchesToCm = (inches) => {
       return Math.round(inches / 0.393701);
     };

    // Function to update measurements
     const updateMeasurements = (toCm = true) => {
      // Get all table rows except header
     const rows = table.querySelectorAll("tbody tr");

       rows.forEach((row) => {
        // Get breast, waist, and hip cells (last three cells)
         const cells = row.cells;
         const measurements = [
           cells[4], // Breast
           cells[5], // Waist
           cells[6], // Hip
         ];

         measurements.forEach((cell) => {
           const value = parseFloat(cell.textContent);
           cell.textContent = toCm ? inchesToCm(value) : cmToInches(value);
         });
       });
     };

    // Event listeners for buttons
    cmBtn.addEventListener("click", () => {
      if (!cmBtn.classList.contains("active")) {
        cmBtn.classList.add("active");
        inchesBtn.classList.remove("active");
        updateMeasurements(true);
      }
    });

    inchesBtn.addEventListener("click", () => {
      if (!inchesBtn.classList.contains("active")) {
        inchesBtn.classList.add("active");
        cmBtn.classList.remove("active");
        updateMeasurements(false);
      }
    });
  }

  handleSwatchListForSmallScreens() {
    const swatchList = document.querySelector(
      ".product-selector__buttons.option-size .swatches ul"
    );
    if (!swatchList) return; // If element doesn't exist, stop execution

    let displaySelection = document.createElement("div");
    displaySelection.className = "swatch-selection";
    displaySelection.textContent = "Select a size"; // Default text
    swatchList.parentNode.insertBefore(displaySelection, swatchList);

    if (window.matchMedia("(max-width: 749px)").matches) {
      displaySelection.addEventListener("click", function () {
        swatchList.classList.toggle("active");
      });

      swatchList.querySelectorAll("li").forEach((li) => {
        li.addEventListener("click", function () {
          const label = li.querySelector("label");

          if (label) {
            label.click();
          }

          const selectedValue = li.querySelector("span").textContent;
          displaySelection.textContent = selectedValue;

          swatchList.classList.remove("active");
        });
      });

      document.addEventListener("click", function (event) {
        if (
          !swatchList.contains(event.target) &&
          !displaySelection.contains(event.target)
        ) {
          swatchList.classList.remove("active");
        }
      });
    }
  }

  variantColorSwatch() {
    // trigger image
    const imgs = document.querySelectorAll(
      ".product-selector .option-color .variant-image"
    );
    const imgsTrigger = document.querySelectorAll(
      ".product-color-selection .product-variants-swatch__image"
    );

    imgsTrigger.forEach((swatch) => {
      const title = swatch.getAttribute("title");
      const imgUrl = swatch.getAttribute("data-image");

      // Find the corresponding img element based on title
      imgs.forEach((img) => {
        if (img.getAttribute("alt") === title) {
          // Assuming img has 'alt' attribute matching title
          img.src = imgUrl; // Set the src of the img to the data-image URL
        }
      });
    });
    // end trigger image

    // Update swatch label
    const name = document.querySelector(".product-selector__label .color-name");
    const buttons = document.querySelectorAll(
      ".product-selector .option-color .swatch"
    );

    const activeSwatch = document.querySelector(
      ".product-selector .option-color .swatch.is-active .variant-image"
    );
    if (activeSwatch) {
      name.innerHTML = activeSwatch.alt; // Use innerHTML to set the default label
    }

    buttons.forEach((button) => {
      const value = button.querySelector(".variant-image").alt;

      button.addEventListener("mouseenter", () => {
        name.innerHTML = value;
      });

      button.addEventListener("mouseleave", () => {
        const activeSwatch = document.querySelector(
          ".product-selector .option-color .swatch.is-active .variant-image"
        );
        if (activeSwatch) {
          name.innerHTML = activeSwatch.alt; // Reset to the active swatch's label
        }
      });
    });
    // end update swatch label
  }

  inactiveOptions() {
    const atc = document.querySelector(".product__atc");
    const atcSelectSize = document.querySelector(".product__atc-select-size");

    this.querySelectorAll('input[type="radio"][name="options[Size]"]').forEach(
      (input) => {
        input.nextElementSibling.classList.remove("is-active");

        input.nextElementSibling.addEventListener("click", function () {
          this.classList.add("is-active");

          atc.classList.remove("hidden");
          atcSelectSize.classList.add("hidden");
        });
      }
    );
  }

  // updateVariantStatuses() {
  //   const optionOneValue = this.querySelector(
  //     this.inputWrapper
  //   ).querySelector(':checked').value;
  //   const selectedOptionOneVariants = this.variants.filter(
  //     variant => optionOneValue === variant.option1
  //   );
  //   const inputWrappers = [
  //     ...this.querySelectorAll(this.inputWrapper)
  //   ];

  //   inputWrappers.forEach((option, index) => {
  //     if (index === 0) return;

  //     const previousOptionSelected =
  //       inputWrappers[index - 1].querySelector(':checked').value;
  //     const listOfAvailableOptions = selectedOptionOneVariants
  //       .filter(
  //         variant =>
  //           variant.available &&
  //           variant[`option${index}`] === previousOptionSelected
  //       )
  //       .map(variantOption => variantOption[`option${index + 1}`]);

  //     const optionInputs = [
  //       ...option.querySelectorAll('input[type="radio"], option')
  //     ];

  //     optionInputs.forEach(input => {
  //       const inputIsDisabled = !listOfAvailableOptions.includes(
  //         input.getAttribute('value')
  //       );

  //       input.disabled = inputIsDisabled;
  //       if (input.tagName.toLowerCase() === 'option') {
  //         const escapedValue = input.value.replace(/"/g, '\\"');
  //         const selector = `button[data-value="${escapedValue}"]`;
  //         const button = input
  //           .closest('dropdown-input')
  //           .querySelector(selector);
  //         if (button) {
  //           button.disabled = inputIsDisabled;
  //         }
  //       }
  //       if (!this.productBar) return;
  //       const inputId = input.dataset.id || input.id;
  //       const productBarInput = this.productBar.querySelector(
  //         `option[data-id="${inputId}"]`
  //       );
  //       if (!productBarInput) return;
  //       productBarInput.disabled = inputIsDisabled;
  //     });
  //   });
  // }

  updateVariantStatuses() {
    const optionOneValue = this.querySelector(this.inputWrapper).querySelector(
      ":checked"
    ).value;
    const selectedOptionOneVariants = this.variants.filter(
      (variant) => optionOneValue === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(this.inputWrapper)];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return; // Skip the first option

      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const listOfAvailableOptions = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);

      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];

      optionInputs.forEach((input) => {
        const inputValue = input.getAttribute("value");
        const inputIsUnavailable = !listOfAvailableOptions.includes(inputValue);

        // Remove the disabled attribute and toggle the 'is-disabled' class based on availability
        input.disabled = false; // Always remove the disabled attribute
        input.classList.toggle("is-disabled", inputIsUnavailable); // Add 'is-disabled' class if unavailable

        // Handle <option> elements inside dropdowns
        if (input.tagName.toLowerCase() === "option") {
          const escapedValue = input.value.replace(/"/g, '\\"');
          const selector = `button[data-value="${escapedValue}"]`;
          const button = input
            .closest("dropdown-input")
            .querySelector(selector);
          if (button) {
            button.classList.toggle("is-disabled", inputIsUnavailable); // Add 'is-disabled' class to the button
          }
        }

        // Ensure inputs in the product bar remain visually disabled
        if (this.productBar) {
          const inputId = input.dataset.id || input.id;
          const productBarInput = this.productBar.querySelector(
            `option[data-id="${inputId}"]`
          );
          if (productBarInput) {
            productBarInput.disabled = false;
            productBarInput.classList.toggle("is-disabled", inputIsUnavailable); // Add 'is-disabled' to the product bar input
          }
        }
      });
    });
  }

  onVariantChange(event) {
    if (event.target.type === "number") return;
    this.updateOptions();
    if (this.currentVariant === this.getVariantData()) return;

    this.updateVariant();
    this.updateVariantStatuses();
    this.productBarUpdateOptions();
    this.updatePickupAvailability();
    if (this.form) {
      this.form.removeAttribute("data-has-selling-plan");
      this.form.toggleAddButton(false, "");
      this.form.handleErrorMessage();
    }

    if (!this.currentVariant) {
      if (this.form) {
        this.form.toggleAddButton(true, "");
      }
      this.setUnavailable();

      return;
    }

    if (!this.currentVariant.available) {
      if (this.form) {
        this.form.toggleAddButton(true, window.variantStrings.soldOut);
      }
    }

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
    this.productColorsMetafield();
  }

  updateOptions() {
    this.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.nextElementSibling.classList.toggle("is-active", input.checked);
    });
    this.options = Array.from(
      this.querySelectorAll('input[type="radio"]:checked, select'),
      (el) => ({ name: el.dataset.name || el.name, value: el.value })
    );

    // remove is-active of size option
    const atc = document.querySelector(".product__atc");
    if (atc.classList.contains("hidden")) {
      this.querySelectorAll(
        'input[type="radio"][name="options[Size]"]'
      ).forEach((input) => {
        input.nextElementSibling.classList.remove("is-active");
      });
    }
  }

  productBarUpdateOptions() {
    if (this.productBar) {
      Array.from(this.productBar.querySelectorAll("select")).map((selector) => {
        selector.value = this.options.find(
          (option) => option.name === selector.name
        ).value;
      });
      this.productBar.querySelectorAll("dropdown-input").forEach((dropdown) => {
        dropdown.update();
      });
    }
  }

  updateInventoryNotice(html) {
    const destination = document.querySelector("[data-inventory-notice]");
    const source = html.querySelector("[data-inventory-notice]");

    if (source && destination) destination.innerHTML = source.innerHTML;

    // Pass the inventory quantity from source to the quantity input
    const inventoryQuantityMatch = source?.textContent.match(/\d+/);
    const inventoryQuantity = inventoryQuantityMatch
      ? parseInt(inventoryQuantityMatch[0])
      : 0;
    this.updateQuantityInput(inventoryQuantity);
  }

  // updateQuantityInput(inventoryQuantity) {
  //   const selectedVariantData = this.getVariantData();
  //   const quantityInput = document.querySelector('.product-selector__quantity quantity-input input');

  //   let productUsesInventory = true;

  //   // check inventory is active
  //   if (selectedVariantData && selectedVariantData.inventory_management === null) {
  //     productUsesInventory = false;
  //   }

  //   // check sell on sold out is active
  //   if (selectedVariantData && selectedVariantData.inventory_quantity !== null && inventoryQuantity === 0 && selectedVariantData.available === true) {
  //     productUsesInventory = false;
  //   }

  //   if (quantityInput) {
  //     if (productUsesInventory) {
  //       quantityInput.setAttribute('max', inventoryQuantity);
  //       // set value accordingly to inventory
  //       if (quantityInput.value > inventoryQuantity) {
  //         quantityInput.value = inventoryQuantity;
  //       }
  //     } else {
  //       quantityInput.setAttribute('max', '');
  //     }
  //   }
  // }

  updateQuantityInput(inventoryQuantity) {
    const selectedVariantData = this.getVariantData();
    const quantityInput = document.querySelector(
      ".product-selector__quantity quantity-input input"
    );

    let productUsesInventory = true;

    // check inventory is active
    if (
      selectedVariantData &&
      selectedVariantData.inventory_management === null
    ) {
      productUsesInventory = false;
    }

    // check sell on sold out is active
    if (
      selectedVariantData &&
      selectedVariantData.inventory_quantity !== null &&
      inventoryQuantity === 0 &&
      selectedVariantData.available === true
    ) {
      productUsesInventory = false;
    }

    if (productUsesInventory) {
      quantityInput.setAttribute("max", inventoryQuantity);
      // set value accordingly to inventory
      if (quantityInput.value > inventoryQuantity) {
        // quantityInput.value = inventoryQuantity;
      }
    } else {
      quantityInput.setAttribute("max", "");
    }
  }

  updatePickupAvailability() {
    const pickUpAvailabilityNode = document.querySelector(
      "pickup-availability"
    );

    if (!pickUpAvailabilityNode || !this.currentVariant) return;

    pickUpAvailabilityNode.dataset.variantId = this.currentVariant.id;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailabilityNode.setAttribute("available", "");
      pickUpAvailabilityNode.fetchAvailability(
        pickUpAvailabilityNode.dataset.variantId
      );

      return;
    }

    pickUpAvailabilityNode.removeAttribute("available");
    pickUpAvailabilityNode.innerHTML = "";
  }

  updateVariant() {
    this.currentVariant = this.getVariantData();
  }

  getVariantData() {
    if (this.options.length === 0) {
      return this.variants[0]; // Return the first variant if no options are selected
    }

    return this.variants.find((variant) => {
      // Check if the variant's options match the selected options
      return this.options.every((option) => {
        const optionIndex =
          this.options.findIndex((opt) => opt.name === option.name) + 1;
        return variant[`option${optionIndex}`] === option.value;
      });
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const productMedia = document.querySelector("product-media");
    productMedia.setActiveMedia(this.currentVariant.featured_media.id);
  }

  updateURL(sellingPlanId) {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has("variant") ? "set" : "append"](
      "variant",
      this.currentVariant.id
    );
    if (sellingPlanId) {
      params[params.has("selling_plan") ? "set" : "append"](
        "selling_plan",
        sellingPlanId
      );
    } else {
      params.delete("selling_plan");
    }
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?${params.toString()}`
    );
  }

  updateVariantInput() {
    const inputs = [
      this.querySelector('[name="id"]'),
      this.installmentsForm?.querySelector('[name="id"]'),
    ];
    inputs.forEach((input) => {
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  setUnavailable() {
    const submitButton = this.form.submitButton;
    const price = this.querySelector(
      `#Product-Price-${this.dataset.sectionId}`
    );

    if (!submitButton) return;
    submitButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  renderProductInfo() {
    const params = new URLSearchParams(window.location.search);
    params[params.has("variant") ? "set" : "append"](
      "variant",
      this.currentVariant.id
    );
    params.append("section_id", this.dataset.sectionId);

    fetch(`${this.dataset.url}?${params.toString()}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        [
          `#Product-Price-${this.dataset.sectionId}`,
          `#Product-Purchase-Options-${this.dataset.sectionId}`,
        ].map((liveRegionSelector) => {
          const destination = document.querySelector(liveRegionSelector);
          const source = html.querySelector(liveRegionSelector);

          this.updateInventoryNotice(html);

          if (destination && source) {
            destination.classList.remove("visibility-hidden");
            destination.innerHTML = source.innerHTML;
          }
        });
      });
  }
}

customElements.define("product-selector", ProductSelector);
